import P from "prop-types";
import * as S from "../styles";

import { SimpleLineChart } from "../../Echarts/SimpleLineChart";
import { CircularProgress } from "@material-ui/core";

export function SimpleLineChartCard({
  dados,
  title,
  style,
  error,
  grid = false,
  colorPallet,
  loading
}) {
  return (
    <S.Container grid={grid}>
      <p>{title}</p>
      {loading && 
      <S.ErrorContainer>
        <CircularProgress color="primary" />
      </S.ErrorContainer>}
      {dados !== undefined &&
        <SimpleLineChart
          grid={grid}
          style={style}
          dados={dados}
          paletaDeCores={colorPallet}
        />}
      {error && <S.ErrorContainer>{error}</S.ErrorContainer>}

    </S.Container>
  );
}

SimpleLineChartCard.propTypes = {
  title: P.string.isRequired,
  grid: P.bool,
  style: P.object.isRequired,
  colorPallet: P.arrayOf(P.string.isRequired).isRequired,
  dados: P.arrayOf(
    P.shape({ name: P.string.isRequired, value: P.number.isRequired })
  ).isRequired,
};
